export default __webpack_public_path__ + "static/media/Graphics_back-min.954869c5.jpg";